<template>
  <div class="dashboard-promotional-panel-wrapper">
    <div class="dashboard-promotional-panel-slider-wrapper" @mouseenter="stopSlider" @mouseleave="startSlider">
      <div class="dashboard-promotional-panel-slider">
        <a
          class="promotional-slide"
          v-for="(slide, index) in promotional_slides"
          :key="`promo_${index}`"
          :href="slide.link"
          target="_blank"
          :style="slideStyle(slide)"
          :class="{
            '_image-left': slide.main_image_side === 'left',
            '_image-right': slide.main_image_side === 'right',
            '_image-none': slide.main_image_side === 'none',
            'active': index === slider_current_index,
            'inactive': index !== slider_current_index
          }"
        >
          <div class="promotional-slide-image">
            <img :src="`${$aws_bucket_url}${slide.main_image_url}`">
          </div>
          <div class="promotional-slide-body">
            <h1 class="promotional-slide-title">{{ slide.title }}</h1>
            <div class="promotional-slide-content">
              {{ slide.content }}
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="slider-nav mt-3">
      <div
        v-for="(promotional_slide, index) in promotional_slides"
        :key="index"
        class="slider-nav-item"
        :class="{ active: index === slider_current_index }"
        @click="goToSlide(index)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["promotional_slides"],
  data() {
    return {
      slider_current_index: 0,
      slider_timer: null,
    };
  },
  mounted() {
    this.slider_current_index = 1;
    this.startSlider();
  },
  methods: {
    startSlider() {
      this.slider_timer = setInterval(() => {
        this.nextSlide();
      }, 4000);
    },
    stopSlider() {
      clearInterval(this.slider_timer);
    },
    nextSlide() {
      this.slider_current_index =
        (this.slider_current_index + 1) % (this.pageLength);
    },
    goToSlide(index) {
      this.slider_current_index = index;
    },
    slideStyle(slide) {
      return {
        backgroundImage: `url(${this.$aws_bucket_url}${slide.background_image_url})`,
        color: slide.text_colour,
        backgroundSize: "cover",
      };
    }
  },
  computed: {
    pageLength() {
      return this.promotional_slides.length;
    }
  },
};
</script>
